import React, { useEffect, useState } from 'react';
import moment from "moment";

import { P2, P3, P4 } from '../../../../Common/DesignSystem/Text';
import { DeviceStatus } from '../DeviceStatus';
import colours from '../../../../Common/DesignSystem/Colours';
import { Trans } from 'react-i18next';

import { useGeolocationContext } from '../hooks/geolocationContext';

export const MarkerPopup = ({ vehicle }) => {
	const { lastUpdated, getAddress } = useGeolocationContext();
	const [popupTitle, setPopupTitle] = useState('');

	if (!vehicle?.gpsDevice) return null;

	useEffect(() => {
		const { latitude, longitude, geocodeAddress } = vehicle?.gpsDevice?.deviceStatus;

		if (geocodeAddress?.formattedAddress) {
			setPopupTitle(geocodeAddress.formattedAddress);
		} else if (latitude && longitude) {
			getAddress(latitude, longitude, setPopupTitle);
		}
	}, []);

	const isDeviceOnline = vehicle?.gpsDevice?.deviceStatus?.isDeviceCommunicating;

	return (
		<div className="vehicle-popup">
			<P2 style={{ color: colours.primary.grey01 }}>
				{popupTitle}
			</P2>
			<div className="device-info popup-device-info">
				<div className="device-status">
					<P3 style={{ color: colours.primary.grey02 }}>
						<Trans>Device Status: </Trans>
					</P3>
					<DeviceStatus isDeviceOnline={isDeviceOnline} />
				</div>
				<div>
					<P4 style={{ color: colours.primary.grey02 }}>
						<Trans>Last Update: </Trans>
						{moment(lastUpdated).format('MMM D, YYYY h:mm')}
					</P4>
				</div>
			</div>
		</div>
	)
}
